module.exports = __webpack_public_path__ + "static/media/15.88811349.svg";